<template>
  <BaseLayout>
    <div class="page-single">
      <b-container
        fluid
      >
        <b-row class="justify-content-center">
          <b-col
            cols="3"
          >
            <b-card
              no-body
            >
              <b-card-body>
                <h4 class="text-center my-5">
                  Complete your account setup
                </h4>
                <b-form
                  class="mt-5"
                >
                  <b-row>
                    <b-col cols="12">
                      <b-form-group
                        id="fieldset-1"
                        label="First Name"
                        label-class="form-label"
                        label-for="input-1"
                      >
                        <b-form-input
                          id="input-1"
                          v-model="account.firstName"
                          autocomplete="off"
                          data-test="on-boarding-firstName"
                          trim
                          :maxlength="maxNameLength"
                        />
                      </b-form-group>
                      <div
                        class="alert alert-danger"
                        v-if="fieldlMaxLength(this.account.firstName, maxNameLength)"
                      >
                        <span>Reached maximum length of 255 characters.</span>
                      </div>
                      <b-form-group
                        id="fieldset-2"
                        label="Last Name"
                        label-class="form-label"
                        label-for="input-2"
                      >
                        <b-form-input
                          id="input-2"
                          v-model="account.lastName"
                          autocomplete="off"
                          data-test="on-boarding-lastName"
                          trim
                          :maxlength="maxNameLength"
                        />
                      </b-form-group>
                      <div
                        class="alert alert-danger"
                        v-if="fieldlMaxLength(this.account.lastName, maxNameLength)"
                      >
                        <span>Reached maximum length of 255 characters.</span>
                      </div>
                      <b-form-group
                        id="fieldset-3"
                        label="What is the name of your company?"
                        label-class="form-label"
                        label-for="input-3"
                      >
                        <b-form-input
                          id="input-3"
                          v-model="account.companyName"
                          autocomplete="off"
                          data-test="on-boarding-companyName"
                          trim
                          :maxlength="maxCompanyName"
                        />
                      </b-form-group>
                      <div
                        class="alert alert-danger"
                        v-if="fieldlMaxLength(account.companyName, maxCompanyName)"
                      >
                        <span>Reached maximum length of 120 characters.</span>
                      </div>
                      <b-form-group
                        id="fieldset-4"
                        label="What would you like your advertiser name to be?"
                        label-class="form-label"
                        label-for="input-4"
                      >
                        <b-form-input
                          id="input-4"
                          v-model="advertiserName"
                          autocomplete="off"
                          data-test="on-boarding-advertiserName"
                          trim
                          :maxlength="maxAdvertiserName"
                        />
                      </b-form-group>
                      <div
                        class="alert alert-danger"
                        v-if="fieldlMaxLength(advertiserName, maxAdvertiserName)"
                      >
                        <span>Reached maximum length of 120 characters.</span>
                      </div>
                    </b-col>
                  </b-row>
                  <div class="form-footer">
                    <b-button
                      id="submit"
                      variant="primary"
                      @click="onSubmit"
                      block
                      :disabled="isDisabled"
                      data-test="on-boarding-submit"
                    >
                      Submit
                    </b-button>
                  </div>
                </b-form>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </BaseLayout>
</template>

<script>
import {
  mapActions,
} from 'vuex';
import * as accountTypes from '@/modules/account/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'OnBoarding',
  components: {
  },
  data() {
    return {
      account: {
        firstName: '',
        lastName: '',
        companyName: '',
      },
      advertiserName: '',
      maxNameLength: 255,
      maxCompanyName: 120,
      maxAdvertiserName: 120,
      clicked: false,
    };
  },
  computed: {
    isDisabled() {
      return !this.account.firstName
      || !this.account.lastName
      || !this.account.companyName
      || !this.advertiserName;
    },
  },
  methods: {
    ...mapActions('account', [
      accountTypes.UPDATE_ACCOUNT,
    ]),
    ...mapActions('campaigns', [
      campaignTypes.CREATE_ADVERTISER,
    ]),
    onSubmit() {
      if (this.clicked || this.isDisabled) {
        return;
      }
      this.clicked = true;
      // this.CREATE_ADVERTISER();
      // this.UPDATE_ACCOUNT(this.account)
      //   .then(() => {
      //     // this.$router.go(-1);
      //   })
      //   .catch(() => {
      //     this.clicked = false;
      //   });
      const advertiserPromise = this.CREATE_ADVERTISER(this.advertiserName);
      const accountPromise = this.UPDATE_ACCOUNT(this.account);
      Promise.all([advertiserPromise, accountPromise])
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => {
          this.clicked = false;
        });
    },
    fieldlMaxLength(field, maxLength) {
      return field.length === maxLength;
    },
  },
};
</script>
